<template>
    <div :class="fieldErrors[id] ? 'error' : ''">
        <label class="block text-gray-700 text-sm font-semibold mb-2" :for="id" v-if="label">{{label}}</label>
        <div class="relative">
            <select
                    :class="[classes(), fieldErrors[id] ? 'border-red-500' : '']"
                    v-model="localValue"
                    :disabled="disabled"
                    :id="id"
                    @change="onChange"
                    class="block appearance-none w-full border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                <option :disabled="!emptyOption" selected :value="null"></option>
                <option v-for="option in options" :key="option[valueKey]" :value="option[valueKey]">
                    {{ option[labelKey] }}
                </option>
            </select>
            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                     viewBox="0 0 20 20">
                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                </svg>
            </div>
        </div>
        <div v-if="fieldErrors[id]" class="text-red-500 text-xs italic">
            {{fieldErrors[id]}}
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                localValue: this.value
            }
        },
        model: {
            prop: 'value',
            event: 'input'
        },
        props: {
            value: {},
            options: {
                type: Array,
                default: () => []
            },
            placeholder: {
                type: String,
                default: ''
            },
            disabled: {
                type: Boolean,
                default: false
            },
            id: {
                type: String,
                required: true
            },
            label: {
                type: String
            },
            fieldErrors: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            size: {
                type: String,
                default: 'md'
            },
            labelKey: {
                type: String,
                default: 'label'
            },
            valueKey: {
                type: String,
                default: 'value'
            },
            emptyOption: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            onChange() {
                this.$nextTick(() => {
                    this.$emit('change', this.localValue)
                })
            },
            classes() {
                let paddingMap = {
                    xs: 'py-1 px-2',
                    sm: 'py-2 px-3',
                    md: 'py-3 px-4',
                    lg: 'py-4 px-5',
                };
                let textSizesMap = {
                    xs: 'text-xs',
                    sm: 'text-sm',
                    md: 'tert-base',
                    lg: 'text-lg',
                };

                let padding = paddingMap[this.size];
                let text = textSizesMap[this.size];
                let disabled = this.disabled ? 'text-gray-300 cursor-not-allowed' : 'bg-gray-200';

                return `${text} ${padding} ${disabled}`
            }
        },
        watch: {
            value(newVal) {
                this.localValue = newVal
            },
            localValue() {
                this.$emit('input', this.localValue)
            }
        },
    }
</script>
